import { render, staticRenderFns } from "./OwalEventBanner.vue?vue&type=template&id=6782a4ed&scoped=true"
import script from "./OwalEventBanner.vue?vue&type=script&lang=js"
export * from "./OwalEventBanner.vue?vue&type=script&lang=js"
import style0 from "./OwalEventBanner.vue?vue&type=style&index=0&id=6782a4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6782a4ed",
  null
  
)

export default component.exports